import {defineAsyncComponent} from 'vue';

const userManagementDetail = defineAsyncComponent(() =>
  import('@/views/system/usermanagement/UserManagementDetail.vue'),
);
const userManagementForUnitDetail = defineAsyncComponent(() =>
  import('@/views/system/usermanagement/UserManagementForUnitDetail.vue'),
);
const roleDetail = defineAsyncComponent(() => import('@/views/system/role/RoleDetail.vue'));
const setRolePopup = defineAsyncComponent(() => import('@/views/system/role/SetRolePopup.vue'));
import HistoryDataManagementPopup from '@/views/system/dataManagement/popup/HistoryDataManagementPopup.vue';
const popupQuickReport = defineAsyncComponent(() => import('@/views/system/quickReport/QuickReportDetail.vue'));
const popupRenameData = defineAsyncComponent(() => import('@/views/system/dataManagement/popup/RenameDataPopup.vue'));
const popupAccountingDataInformation = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/AccountingDataInformation.vue'),
);
const popupSelectAccountingData = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/SelectAccountingDataPopup.vue'),
);
const popupBackupAccountingData = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/BackupAccountingDataPopup.vue'),
);

const popupRestoreAccountingData = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/RestoreAccountingDataPopup.vue'),
);

const popupOverBackupData = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/OverBackupDataPopup.vue'),
);

const popupBackupRestoreProcessx = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/BackupRestoreProcessPopup.vue'),
);

const CopyDataProgressPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/CopyDataProgressPopup.vue'),
);

const popupCreateDatabaseFromOldDataProcessx = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/CreateDatabaseFromOldDataProcessPopup.vue'),
);

const popupChangeDatabaseUse = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/ChangeDatabaseUsePopup.vue'),
);

const popupConfirmDelete = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/ConfirmDeletePopup.vue'),
);
// popup chọn tài khoản
const popupSelectBankAccount = defineAsyncComponent(() =>
  import('@/views/system/companyinfo/SelectBankAccountPopup.vue'),
);
const sortRefNo = defineAsyncComponent(() => import('@/views/system/sortRefNo/popup/SortRefNo.vue'));
const sortRefNoResult = defineAsyncComponent(() => import('@/views/system/sortRefNo/popup/SortRefNoResult.vue'));
const voucherSearchList = defineAsyncComponent(() => import('@/views/system/voucherSearch/VoucherSearchList.vue'));
const analysisFormDetail = defineAsyncComponent(() => import('@/views/system/voucherSearch/AnalysisFormDetail.vue'));

//thêm chứng từ
const voucherAdd = defineAsyncComponent(() => import('@/views/system/voucherAdd/VoucherAdd.vue'));

//cập nhật thông tin đơn vị
const FormUpdateTenant = defineAsyncComponent(() => import('@/views/formTenant/FormUpdateTenant.vue'));

// in danh sách chứng từ
const printVoucher = defineAsyncComponent(() => import('@/views/system/voucherSearch/PrintVoucher.vue'));

// Cảnh báo hết hạn phần mềm
const expiredNoti = defineAsyncComponent(() => import('@/views/system/notification/ExpiredNotification.vue'));

// Popup chọn option tạo dữ liệu mới
const popupCreateDatabaseOption = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/CreateDatabaseOptionPopup.vue'),
);

// kết quả convert dữ liệu
const resultConvert = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/resultConvert/ResultConvert.vue'),
);
// kết quả convert dữ liệu
const resultDifferenceArisePopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/resultConvert/ResultDifferenceArisePopup.vue'),
);

// Gia hạn form
const extendForm = defineAsyncComponent(() => import('@/views/extendForm/ExtendForm.vue'));

// thiết lập hiển thị
const displaySettingPopup = defineAsyncComponent(() =>
  import('@/views/system/displaySettingPopup/DisplaySettingPopup.vue'),
);
const settlementInstructionsAdvancePaymentStep = defineAsyncComponent(() =>
  import('@/views/settlementInstructions/SettlementInstructionsAdvancePaymentStep.vue'),
);

// Màn liên quan hướng dẫn quyết toán - đối chiếu số liệu
const settlementInstructionsDataReconciliationMain = defineAsyncComponent(() =>
  import('@/views/settlementInstructions/dataReconciliation/SettlementInstructionsDataReconciliation.vue'),
);
const AccountDetailSettlementPopup = defineAsyncComponent(() =>
  import('@/views/settlementInstructions/dataReconciliation/popups/AccountDetailSettlementPopup.vue'),
);

// Màn hình hướng dẫn quyết toán - kết chuyển
const settlementInstructionsAccountTransfer = defineAsyncComponent(() =>
  import('@/views/settlementInstructions/accountTransfer/SettlementInstructionsAccountTransfer.vue'),
);

// Màn liên quan hướng dẫn quyết toán - đối chiếu số liệu
const settlementInstructionsTreasuryCompare = defineAsyncComponent(() =>
  import('@/views/settlementInstructions/treasuryCompare/SettlementInstructionsTreasuryCompare.vue'),
);

//Popup danh sách chứng từ chưa chọn hoạt động
const notActionVoucherPopup = defineAsyncComponent(() =>
  import('@/views/settlementInstructions/dataReconciliation/popups/NotActionVoucher.vue'),
);
const resultCopyData = defineAsyncComponent(() => import('@/views/copyData/resultCopyData/ResultCopyData.vue'));

export function registerSystem(app) {
  app.component('HistoryDataManagementPopup', HistoryDataManagementPopup);
  app.component('RenameDataPopup', popupRenameData);
  app.component('AccountingDataInformation', popupAccountingDataInformation);
  app.component('SelectAccountingDataPopup', popupSelectAccountingData);
  app.component('UserManagementDetail', userManagementDetail);
  app.component('UserManagementForUnitDetail', userManagementForUnitDetail);
  app.component('RoleDetail', roleDetail);
  app.component('SetRolePopup', setRolePopup);
  app.component('QuickReportPopup', popupQuickReport);
  app.component('SortRefNo', sortRefNo);
  app.component('SortRefNoResult', sortRefNoResult);
  app.component('BackupAccountingDataPopup', popupBackupAccountingData);
  app.component('RestoreAccountingDataPopup', popupRestoreAccountingData);
  app.component('OverBackupDataPopup', popupOverBackupData);
  app.component('BackupRestoreProcessPopupX', popupBackupRestoreProcessx);
  app.component('CreateDatabaseFromOldDataProcessx', popupCreateDatabaseFromOldDataProcessx);
  app.component('ChangeDatabaseUsePopup', popupChangeDatabaseUse);
  app.component('ConfirmDeletePopup', popupConfirmDelete);
  app.component('SelectBankAccountPopup', popupSelectBankAccount);
  app.component('VoucherSearch', voucherSearchList);
  app.component('VoucherAdd', voucherAdd);
  app.component('PrintVoucher', printVoucher);
  app.component('ExpiredNotification', expiredNoti);
  app.component('FormUpdateTenant', FormUpdateTenant);
  app.component('ResultConvert', resultConvert);
  app.component('CreateDatabaseOptionPopup', popupCreateDatabaseOption);
  app.component('ResultDifferenceArisePopup', resultDifferenceArisePopup);
  app.component('ExtendForm', extendForm);
  app.component('AnalysisFormDetail', analysisFormDetail);
  app.component('DisplaySettingPopup', displaySettingPopup);
  app.component('SettlementInstructionsAdvancePaymentStep', settlementInstructionsAdvancePaymentStep);
  app.component('SettlementInstructionsDataReconciliation', settlementInstructionsDataReconciliationMain);
  app.component('AccountDetailSettlementPopup', AccountDetailSettlementPopup);
  app.component('SettlementInstructionsAccountTransfer', settlementInstructionsAccountTransfer);
  app.component('SettlementInstructionsTreasuryCompare', settlementInstructionsTreasuryCompare);
  app.component('NotActionVoucherPopup', notActionVoucherPopup);
  app.component('ResultCopyData', resultCopyData);
  app.component('CopyDataProgressPopup', CopyDataProgressPopup);
}
